import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { COMPANY } from '../../constants/company';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signIn(email, password);
    } catch (err: any) {
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/user-not-found') {
        setError('E-mail ou senha incorretos.');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Muitas tentativas. Aguarde alguns minutos.');
      } else {
        setError('Acesso negado. Apenas administradores podem entrar.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt={COMPANY.name} style={styles.logo} />
          <h1 style={styles.title}>{COMPANY.appName}</h1>
          <p style={styles.subtitle}>Painel do Gestor</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}

          <label style={styles.label}>E-mail</label>
          <input
            type="email"
            style={styles.input}
            placeholder="admin@empresa.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />

          <label style={styles.label}>Senha</label>
          <div style={styles.passwordWrapper}>
            <input
              type={showPassword ? 'text' : 'password'}
              style={{ ...styles.input, paddingRight: 44, width: '100%', boxSizing: 'border-box' }}
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              style={styles.eyeBtn}
              onClick={() => setShowPassword(s => !s)}
              tabIndex={-1}
              title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
            >
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div style={styles.footer}>
          <p style={styles.footerCompany}>{COMPANY.name}</p>
          <p style={styles.footerInfo}>CNPJ: {COMPANY.cnpj}</p>
          <p style={styles.footerInfo}>Versão {COMPANY.version}</p>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #c2410c 0%, #f5821f 100%)',
  },
  card: {
    background: '#fff',
    borderRadius: 20,
    padding: '40px 48px',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
  },
  header: {
    textAlign: 'center',
    marginBottom: 32,
  },
  logo: { width: 84, height: 84, borderRadius: 16, objectFit: 'contain' },
  title: { fontSize: 28, fontWeight: 700, color: '#1a1a2e', margin: '12px 0 4px' },
  subtitle: { color: '#666', margin: 0 },
  form: { display: 'flex', flexDirection: 'column' },
  error: {
    background: '#fef2f2',
    color: '#dc2626',
    border: '1px solid #fecaca',
    borderRadius: 8,
    padding: '10px 14px',
    marginBottom: 16,
    fontSize: 14,
  },
  label: { fontSize: 14, fontWeight: 600, color: '#444', marginBottom: 6, marginTop: 12 },
  passwordWrapper: { position: 'relative', display: 'flex', alignItems: 'center' },
  eyeBtn: { position: 'absolute', right: 8, background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, padding: 4, lineHeight: 1 },
  input: {
    border: '1px solid #e0e0e0',
    borderRadius: 10,
    padding: '12px 14px',
    fontSize: 15,
    color: '#333',
    outline: 'none',
    background: '#fafafa',
  },
  button: {
    background: '#f5821f',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    padding: '14px',
    fontSize: 16,
    fontWeight: 700,
    cursor: 'pointer',
    marginTop: 24,
  },
  footer: { textAlign: 'center', marginTop: 24, paddingTop: 16, borderTop: '1px solid #f0f0f0' },
  footerCompany: { fontSize: 13, fontWeight: 600, color: '#666', margin: 0 },
  footerInfo: { fontSize: 11, color: '#aaa', margin: '2px 0 0' },
};
